export default "__VITE_ASSET__BiXjCOxK__"